import {ScreenType, BaseTemplateProps} from "../types/templates.ts";
const modules = import.meta.glob('@/components/templates/**/*.tsx') as Record<string, () => Promise<{ default: React.ComponentType<BaseTemplateProps> }>>;

interface GetTemplateComponentProps {
    template: string;
    screenType: ScreenType;
}

const TEMPLATES_BASE_PATH = `/src/components/templates`;

export const getTemplateComponentPath = (props: GetTemplateComponentProps) => {
    const {template, screenType} = props;

    if (!template) {
        throw new Error("Parameter template is required!");
    }

    const safeTemplateName = template.replace(/[^a-zA-Z0-9_-]/g, "");
    if (safeTemplateName !== template || !safeTemplateName) {
        console.warn(`Potential risk template name: ${template}, used: ${safeTemplateName}`);
        if (!safeTemplateName) throw new Error(`Incorrect template name after sanitization: ${template}!`);
    }

    const pathSegments: string[] = [TEMPLATES_BASE_PATH, safeTemplateName, "views"];

    switch (screenType) {
        case "HomeScreen": {
            pathSegments.push("HomeScreen.tsx");
            return modules[pathSegments.join("/")];
        }
        case "QuizScreen": {
            pathSegments.push("QuizScreen.tsx");
            return modules[pathSegments.join("/")];
        }
        case "ResultScreen": {
            pathSegments.push("ResultScreen.tsx");
            return modules[pathSegments.join("/")];
        }
    }
}